import { render, staticRenderFns } from "./BlogListItem.vue?vue&type=template&id=4840bf18&scoped=true"
import script from "./BlogListItem.vue?vue&type=script&lang=js"
export * from "./BlogListItem.vue?vue&type=script&lang=js"
import style0 from "./BlogListItem.vue?vue&type=style&index=0&id=4840bf18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4840bf18",
  null
  
)

export default component.exports